import { CompanyTheme } from "../types";

export const mockTheme: CompanyTheme= {
  "logo": "https://cdn.cocentric-connect-dev.codeleap.co.uk/media/public/chat_photos/b79dd6cc-e9b2-4dcb-8e32-fc29a8d29d84/profile_photo_69614BB2-D3B9-4160-AE39-BAD3024C.jpeg",
  "primaryColour": "#b05f5f"
}
